// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.marked[data-v-9ae041b8]{\n\tbackground-color:var(--main-color);\n\tcolor:white;\n\tfont-weight: bold;\n}\n.marked[data-v-9ae041b8],.row[data-v-9ae041b8]{\n\tfont-size: 16px;\n}\n.month[data-v-9ae041b8]{\n\ttext-transform: capitalize;\n}\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
